













import BasePageTemplate from '@/views/templates/tenugui/BasePageTemplate.vue'
import TalkAreaTenugui from '@/views/molecules/TalkAreaTenugui.vue'
export default
  components: {
    BasePageTemplate
    TalkAreaTenugui
  }

  data: () ->
    labels: [
      {
        image: '/assets/image/tenugui/miyamoto_icon.png'
        name: '宮本さん'
        text: [
          'スポーツてぬぐいができるまでを学びたいっていう話やけど、どんな子なんだろう。。'
          'あ！もしかしてあの子かな？？'
        ]
      }
      {
        image: '/assets/image/tenugui/suu.svg'
        name: 'スー'
        text: [
          'はじめまして！スーと言います。<br>ここで新しいてぬぐいを作っていると聞いて、やってきたんだ！'
        ]
      }
      {
        image: '/assets/image/tenugui/miyamoto_icon.png'
        name: '宮本さん'
        text: [
          'はじめまして 代表の宮本です！<br>ありがとう！それじゃあ、僕たちがどうやって作ってるか紹介するね！こっちです！'
        ]
      }
    ]

  methods: {
    startScrollFire: (e) ->
      @$emit('scrollFire')
  }

